"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Tabs
 */
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var warning_1 = require("../../utils/warning");
var Aria_1 = require("../../resources/Aria");
var TAB_ID_PREFIX = "__tab";
var TAB_PANEL_ID_PREFIX = "__panel_";
var TabsAppearances;
(function (TabsAppearances) {
    TabsAppearances["Default"] = "default";
    /**
     * Secondary or "compact" tabs should only be used as a second tier of tabs within tabs or in a modal.
     */
    TabsAppearances["Secondary"] = "secondary";
})(TabsAppearances = exports.TabsAppearances || (exports.TabsAppearances = {}));
/**
 * OUI tabs component.
 *
 * @oui-component Tabs
 */
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        // For other extended Component to override
        _this.isVerticalNav = false;
        _this.onSelect = _this.onSelect.bind(_this);
        var tabData = _this.getTabData(props.children);
        var activeTabIndex = props.activeTabIndex !== undefined
            ? props.activeTabIndex
            : _this.findActiveTabIndex();
        if (activeTabIndex >= 0) {
            // in case there aren't any tabs
            var visitedTabs = new Set([activeTabIndex]);
            _this.state = {
                activeTabIndex: activeTabIndex,
                tabData: tabData,
                visitedTabs: visitedTabs
            };
        }
        else {
            _this.state = {
                activeTabIndex: activeTabIndex,
                tabData: tabData,
                visitedTabs: new Set()
            };
        }
        _this.rearrangeDOMStructure = _this.rearrangeDOMStructure.bind(_this);
        return _this;
    }
    Tabs.prototype.componentWillReceiveProps = function (nextProps) {
        var tabData = this.getTabData(nextProps.children);
        var stateActiveTabIndex = nextProps.activeTabIndex !== undefined
            ? nextProps.activeTabIndex
            : this.state.activeTabIndex;
        // if there's fewer tabs, reset the active tab index
        var activeTabIndex = tabData.length !== this.state.tabData.length
            ? this.findActiveTabIndex(nextProps.children)
            : stateActiveTabIndex;
        this.setState({ tabData: tabData, activeTabIndex: activeTabIndex });
    };
    Tabs.prototype.getChildContext = function () {
        return {
            onSelect: this.onSelect,
            activeTabIndex: this.state && this.state.activeTabIndex,
            isVerticalNav: this.isVerticalNav
        };
    };
    Tabs.prototype.render = function () {
        var _a;
        var _b = this.props, _c = _b.appearance, appearance = _c === void 0 ? TabsAppearances.Default : _c, 
        // tslint:disable-next-line:no-unused
        children = _b.children, 
        // tslint:disable-next-line:no-unused
        activeTabIndex = _b.activeTabIndex, rest = __rest(_b, ["appearance", "children", "activeTabIndex"]);
        var newDOM = this.rearrangeDOMStructure();
        var containerClassName = classNames((_a = {},
            _a[this.extraContainerClassName] = !!this.extraContainerClassName,
            _a));
        if (!this.isVerticalNav) {
            this.validateTabChildren(children);
        }
        return this.isVerticalNav ? (React.createElement("nav", __assign({}, rest, { className: containerClassName }),
            React.createElement("ul", { "aria-orientation": "vertical", className: "oui-tab oui-tab-right", role: Aria_1.Roles.Menu }, React.Children.toArray(newDOM.tabMenus)))) : (React.createElement("div", __assign({}, rest, { className: containerClassName }),
            React.createElement("ul", { "aria-orientation": "horizontal", className: classNames("oui-tab", {
                    "oui-tabs__list": appearance === "default",
                    "oui-tabs__list__secondary": appearance === "secondary"
                }), role: Aria_1.Roles.Tablist }, React.Children.toArray(newDOM.tabMenus)),
            React.createElement("div", { className: classNames({
                    "oui-tabs__content": appearance === "default",
                    "oui-tabs__content__secondary": appearance === "secondary"
                }) }, React.Children.toArray(newDOM.tabContents))));
    };
    // Tabs and Vertical Nav are intermingled in oui-react but Links are not supported in Tabs as of oui-react@v4
    Tabs.prototype.validateTabChildren = function (children) {
        if (children === void 0) { children = this.props.children; }
        React.Children.forEach(children, function (child) {
            var childProps = child.props;
            var linkProps = childProps.href ||
                childProps.linkComponent ||
                childProps.linkComponentProps;
            warning_1.default(linkProps !== undefined, "passing href or linkComponent to tabs has been deprecated, this is API for VerticalNav only");
        });
    };
    Tabs.prototype.findActiveTabIndex = function (children) {
        if (children === void 0) { children = this.props.children; }
        var activeTabIndex = -1;
        React.Children.forEach(children, function (child, idx) {
            var childProps = child.props;
            if (childProps && childProps.isDefault) {
                activeTabIndex = idx;
            }
        });
        if (activeTabIndex === -1 && React.Children.count(children) > 0) {
            activeTabIndex = 0;
        }
        return activeTabIndex;
    };
    Tabs.prototype.onSelect = function (idx) {
        var visitedTabsClone = new Set(this.state.visitedTabs);
        visitedTabsClone.add(idx);
        this.setState({
            visitedTabs: visitedTabsClone,
            activeTabIndex: idx
        });
    };
    Tabs.prototype.getTabData = function (rawTabs) {
        return React.Children.map(rawTabs, function (_, idx) {
            var tabId = TAB_ID_PREFIX + Tabs.ID_INDEX++;
            return {
                index: idx,
                menuLinkId: tabId,
                contentPanelId: TAB_PANEL_ID_PREFIX + tabId
            };
        });
    };
    /**
     * Developer will define Tabs like below
     *  <Tabs>
     *     <Tab>  // tab1, and assume this is default tab to be opened
     *       tab panel content ...
     *     </Tab>
     *     <Tab>  // tab2
     *       tab panel content ...
     *     </Tab>
     *  </Tabs>
     *
     *  But when we actually render it, it will be
     *  <div>
     *     <ul><li>tab1</li> <li>tab2</li>
     *     <div>
     *         tab1 content
     *     </div>
     *  At the beginning tab 2 content will not be rendered.
     *  when tab 2 is rendered, tab1 content will be hidden to minimize DOM modification when re-show
     *     <div>
     *         tab2 content
     *     </div>
     *  <div
     */
    Tabs.prototype.rearrangeDOMStructure = function () {
        var _this = this;
        var children = this.props.children;
        var tabData = this.state.tabData;
        var tabContents = [];
        var tabMenus = [];
        React.Children.forEach(children, function (rawTab, idx) {
            var data = tabData[idx];
            var tabWrapper = (React.createElement(TabWrapper, { tab: rawTab, index: idx, linkId: data.menuLinkId, panelId: data.contentPanelId }));
            tabMenus.push(tabWrapper);
            if (_this.state.visitedTabs.has(idx)) {
                var tabContent = (React.createElement("div", { id: data.contentPanelId, role: Aria_1.Roles.Tabpanel, "aria-labelledby": data.menuLinkId, className: classNames({
                        "oui-hidden": _this.state.activeTabIndex !== idx
                    }) }, rawTab.props.children));
                tabContents.push(tabContent);
            }
        });
        return { tabMenus: tabMenus, tabContents: tabContents };
    };
    Tabs.ID_INDEX = 0;
    Tabs.childContextTypes = {
        onSelect: PropTypes.func.isRequired,
        activeTabIndex: PropTypes.number,
        isVerticalNav: PropTypes.bool
    };
    return Tabs;
}(React.Component));
exports.default = Tabs;
var TabWrapper = /** @class */ (function (_super) {
    __extends(TabWrapper, _super);
    function TabWrapper(props) {
        return _super.call(this, props) || this;
    }
    TabWrapper.prototype.getChildContext = function () {
        return {
            index: this.props.index,
            linkId: this.props.linkId,
            panelId: this.props.panelId
        };
    };
    TabWrapper.prototype.render = function () {
        return this.props.tab;
    };
    TabWrapper.childContextTypes = {
        index: PropTypes.number,
        linkId: PropTypes.string,
        panelId: PropTypes.string
    };
    return TabWrapper;
}(React.Component));
//# sourceMappingURL=Tabs.js.map